import React from 'react';
import BurrowLogo from './BurrowLogo';
import styles from './Footer.module.css';

const SERVICES = [
  { label: 'Reddit Engagement', href: '#services' },
  { label: 'Karma Building', href: '#pricing' },
  { label: 'One-time Boosts', href: '#services' },
  { label: 'Subreddit Growth', href: '#services' },
  { label: 'Content & Posting', href: '#services' },
];

const COMPANY = [
  { label: 'How it works', href: '#how' },
  { label: 'Pricing', href: '#pricing' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contact', href: 'mailto:hello@growthburrow.com' },
];

const CONTACT = [
  { label: 'hello@growthburrow.com', href: 'mailto:hello@growthburrow.com' },
  { label: 'Start a plan', href: '#pricing' },
  { label: 'Custom orders', href: 'mailto:hello@growthburrow.com' },
  { label: 'Agency reselling', href: 'mailto:hello@growthburrow.com' },
];

function FooterCol({ title, links }) {
  const handleClick = (href) => {
    if (href.startsWith('#')) {
      const target = document.querySelector(href);
      if (target) window.scrollTo({ top: target.offsetTop - 80, behavior: 'smooth' });
    }
  };

  return (
    <div className={styles.col}>
      <h5 className={styles.colTitle}>{title}</h5>
      <ul className={styles.colList}>
        {links.map((link) => (
          <li key={link.label}>
            {link.href.startsWith('#') ? (
              <button
                className={styles.colLink}
                onClick={() => handleClick(link.href)}
              >
                {link.label}
              </button>
            ) : (
              <a href={link.href} className={styles.colLink}>
                {link.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.inner}>
          {/* Brand */}
          <div className={styles.brand}>
            <a href="/" className={styles.logo}>
              <BurrowLogo height={26} />
            </a>
            <p className={styles.brandDesc}>
              Human-run Reddit engagement for businesses that want real traction
              without the Reddit learning curve.
            </p>
            <div style={{ marginTop: '20px' }}>
              <a 
                href="https://www.linkedin.com/company/growth-burrow/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className={styles.colLink}
                aria-label="LinkedIn"
                style={{ display: 'inline-block' }}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
            </div>
          </div>

          <FooterCol title="Services" links={SERVICES} />
          <FooterCol title="Company" links={COMPANY} />
          <FooterCol title="Contact" links={CONTACT} />
        </div>

        <div className={styles.bottom}>
          <p className={styles.copy}>
            © {new Date().getFullYear()} GrowthBurrow · growthburrow.com · All rights reserved.
          </p>
          <div className={styles.legal}>
            <a href="/privacy" className={styles.legalLink}>Privacy Policy</a>
            <a href="/terms" className={styles.legalLink}>Terms of Service</a>
            <a href="/refunds" className={styles.legalLink}>Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
